
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    props: {
        columns: {
            type: Array as PropType<any[]>,
            default: () => [],
        },
        row: {
            type: Object as PropType<any>,
            required: true,
        },
        index: {
            type: Number,
            default: 0,
        },
        parentIndex: {
            type: Number,
            default: 0,
        },
        tableIndex: {
            type: Number,
            default: 0,
        },
        hasCheckboxColumn: {
            type: Boolean,
            default: false,
        },
        hasIndexColumn: {
            type: Boolean,
            default: false,
        },
        checked: {
            type: Boolean,
            default: false,
        },
        regularTable: {
            type: Boolean,
            default: false,
        },
        isCentered: {
            type: Boolean,
            default: false,
        },
    },
})
